/**
 * Determines the session replay sample rate based on the provided hostname.
 * @returns The session replay sample rate as a number.
 */
export const getSessionReplaySampleRate = (_hostname?: string) => {
  // Session replay is disabled across all environments
  return 0
}
